export function getProgress(remainingDuration, maxDuration) {
    return (remainingDuration / maxDuration) * 100;
}

export function getProgressColorFor(ratio) {
    if (ratio > 25) {
    return "success";
    }
    if (ratio > 10) {
        return "warning";
    }
    return "danger";
}


// WEBPACK FOOTER //
// ./src/components/Shared/SharedUILogic.jsx